import { LOYALTY_DISCOUNT_TYPES } from "../constant/constants";
import ApiService from "../utils/ApiService";
import { getRestaurantId } from "../utils/authUtils";

export const defaultMembershipInfo = {
    loyaltyDiscountInfo: {
      discountTypes: [],
      minRedeemPoint: 0,
      discountPercent: 0,
    },
    restaurantId: "",
    userId: "",
    name: "",
    existingPoint: 0,
    availablePoints: 0,
    isActive: false,
    shouldAddMembership: false,
  };

export const getPointBasedBoundaryValue = (discountType, payableAmount, availablePoints) => {
  if (discountType === 'Amount') {
    return payableAmount;
  }

  if (discountType !== 'Point Based') {
    return payableAmount;
  }

  return Math.min(payableAmount, availablePoints);
}

export const getDefaultDataForMembershipInfo = (order) => {
  if (!order?.userId) {
    return {...defaultMembershipInfo};
  }

  return {
    ...defaultMembershipInfo,
    restaurantId: getRestaurantId(),
    userId: order.userId,
    name: order?.customerName || ''
  };
}

const getApplicableSpendSlab = (discountApplicablePrice, spendBasedSettings) => {
  if (!spendBasedSettings.isActive) {
    return null;
  }

  // Sort slabs by minAmount ascending (just in case)
  const sortedSlabs = [...spendBasedSettings.slabs].sort((a, b) => a.minAmount - b.minAmount);

  // Find the highest slab that the payable amount qualifies for
  let applicableSlab = null;
  for (const slab of sortedSlabs) {
    if (discountApplicablePrice >= slab.minAmount) {
      applicableSlab = slab;
    } else {
      break; // Since sorted, no need to check further
    }
  }

  return applicableSlab; // null if none qualifies
};

const getLoyaltyDiscountInfo = (availablePoints, discountApplicablePrice, loyaltySettings) => {
  const loyaltyDiscountInfo = {
    discountTypes: [],
    minRedeemPoint: 0,
    discountPercent: 0,
  };

  if (!loyaltySettings.isActive) {
    return loyaltyDiscountInfo;
  }

  const applicableSlab = getApplicableSpendSlab(discountApplicablePrice, loyaltySettings.spentBasedSystem);

  if (loyaltySettings.pointBasedSystem.isActive && availablePoints >= loyaltySettings.pointBasedSystem.minRedeemPoint) {
    loyaltyDiscountInfo.discountTypes.push(LOYALTY_DISCOUNT_TYPES[0]);
    loyaltyDiscountInfo.minRedeemPoint = loyaltySettings.pointBasedSystem.minRedeemPoint;
  }

  if (applicableSlab) {
    loyaltyDiscountInfo.discountTypes.push(LOYALTY_DISCOUNT_TYPES[1]);
    loyaltyDiscountInfo.discountPercent = applicableSlab.discountPercent;
  }

  return loyaltyDiscountInfo;
};

export const getFormatedMembershipInfo = (apiResult, order, loyaltySettings, membershipInfo) => {
  const formatedInfo = { ...membershipInfo, ...apiResult };
  // const payableAmount = order.isVatIncluded ?  order.totalPriceBeforeDiscount : order?.foodPriceBeforeDiscount || order.foodPrice;
  formatedInfo.loyaltyDiscountInfo = getLoyaltyDiscountInfo(apiResult.availablePoints, order.discountApplicablePrice, loyaltySettings);

  return formatedInfo;
};

export const isMembershipApplicable = (order, user) => {
  
  const userPhone = `${user.countryCode}${user.phone}`;

  if (user.id && order.userId && order.number !== userPhone) {
    return true;
  }

  return false;
};

/**
 * update printer settings
 *
 * @param {*} params
 * @param {*} token
 */
export const addMembership = async (shouldAdd, params, token) => {
  try {
    if (!shouldAdd) {
      return {
        success: true,
        record: null,
        message: ''
      }
    }

    const reqBody = {
      restaurantId: params.restaurantId,
      userId: params.userId,
      name: params.name,
      existingPoint: 0
    };

    const res = await ApiService.ADD_LOYALTY_MEMBERSHIP(reqBody, token);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Membership added successfully" : res.message,
      record: res.code === 200 ? res.payload.record : null
    };
  } catch (error) {
    return {
      success: false,
      msg: "Faild to add membership",
      record: null
    };
  }
};

/**
 * update printer settings
 *
 * @param {*} params
 * @param {*} token
 */
export const getMembershipInfo = async (params, token) => {
  const result = {
    success: false,
    message: "Failed to get membership info",
    hasMembership: false,
    record: {},
  };

  try {
    const res = await ApiService.GET_LOYALTY_MEMBERSHIP(params, token);

    if (res.code !== 200) {
      result.message = res.message;
      return result;
    }

    result.success = true;
    let { record } = res.payload;

    if (record) {
      result.hasMembership = true;
      result.record = record;
    }

    return result;
  } catch (error) {
    return result;
  }
};
